import {
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import RewardListRow from "./rewardListRow";

interface Props {
  rewards: Reward[];
  onSelect?: (id: string, state: "add" | "remove") => void;
}

export default function RewardList({ rewards, onSelect }: Props) {
  return (
    <div className="mt-3">
      <CTable responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell className="text-sm"></CTableHeaderCell>
            <CTableHeaderCell className="text-sm">Title</CTableHeaderCell>

            <CTableHeaderCell className="text-sm">Type</CTableHeaderCell>

            <CTableHeaderCell className="text-sm">
              Points Requis
            </CTableHeaderCell>

            <CTableHeaderCell className="text-sm">Active</CTableHeaderCell>

            <CTableHeaderCell className="text-sm">Reusable</CTableHeaderCell>

            <CTableHeaderCell className="text-sm">
              isFeatured 
            </CTableHeaderCell>

            <CTableHeaderCell className="text-sm">Actions</CTableHeaderCell>

          </CTableRow>
        </CTableHead>

        <CTableBody>
          {rewards?.map((reward) => (
            <RewardListRow
              key={reward.id}
              reward={reward}
              onSelect={onSelect}
            />
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
}
